export default __webpack_public_path__ + "static/media/no-photo-or-blank-image-icon-loading-images-vector-37375020.24d1f05b.jpg";